/* 商品相关接口 */
import http from '@/utils/http-v4'
import config from '@/config/config'

const api = {
  checkGoodPrice: `${config.apiv4Root}/inner4/ilisten/good:check`,
}

export async function checkGoodPrice(goodId, goodQuantity, price) {
  return http.get(api.checkGoodPrice, {
    good_id: goodId,
    good_quantity: goodQuantity,
    price
  })
}
